// extracted by mini-css-extract-plugin
export var progress = "QuickStartProgress-module--progress--0b553";
export var progressBar = "QuickStartProgress-module--progressBar--4b111";